import { createWebI18n } from "@timeghost/i18n/web";
import { initReactI18next } from "react-i18next";

const i18n = createWebI18n([initReactI18next]);

export default i18n;
